import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { ListView } from './views/ListView';
import { DetailView } from './views/DetailView';

export function App() {
  const [tab, setTab] = useState('Needs Review');
  return (
    <BrowserRouter>
      <div
        style={{
          display: 'flex',
          height: '100vh',
          background: 'var(--a-bg)',
          color: 'var(--a-ink)',
          fontFamily: 'var(--sans)',
        }}
      >
        <Sidebar active={tab} onSelect={setTab} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <Routes>
            <Route path="/" element={<ListView tab={tab} />} />
            <Route path="/books/:id" element={<DetailView />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}
